module.exports = __webpack_public_path__ + "assets/img/driver-btn-1ee2ed81.png";